import type { AssistantLoadingMessage } from '@/entities/discovery';
import { RingSpinner } from '@/shared/components/loader/ring-spinner';
import { AssistantAvatar } from './primitives';

export const AssistantMessageLoading = ({ message }: { message: AssistantLoadingMessage }) => {
  return (
    <div className="flex items-start gap-3">
      <AssistantAvatar />
      <div className="mt-1 flex items-center gap-2">
        <RingSpinner className="size-4" />
        <span className="text-primary text-sm">{message.content.message}</span>
      </div>
    </div>
  );
};
